<template>
  <nav aria-label="breadcrumb">
    <!-- <div class="w-20" v-if="breadcrumbs.length > 1">
      <ButtonVue
        @handleClick="goBack"
        theme="greyOutline"
        size="extraSmall"
        radius="small"
      >
        <img src="@/assets/svg/chevron-left.svg" />
        <p class="">{{ $t("singleProduct.back") }}</p>
      </ButtonVue>
    </div> -->
    <ol class="flex">
      <li
        v-for="(crumb, index) in breadcrumbs"
        :key="index"
        class="flex items-center"
      >
        <router-link
          :to="{
            path: crumb.path?.includes('/') ? crumb.path : null,
            name: !crumb.path?.includes('/') ? crumb.path : null,
            query: crumb.query || {},
          }"
          :class="getCrumbClass(crumb.path, index)"
        >
          {{ crumb.label }}
        </router-link>
        <span v-if="index < breadcrumbs.length - 1" class="mx-2 text-gray-400">
          <img src="@/assets/svg/chevron-right.svg" alt="" />
        </span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
    },
  },
  methods: {
    isCurrentRoute(path) {
      return this.$route.path === path || this.$route.name === path;
    },
    goBack() {
      this.$router.back();
    },

    getCrumbClass(path, index) {
      if (this.isCurrentRoute(path)) {
        // Apply 'millik' class for the current route
        return "text-[#000] text-xl font-millik";
      } else {
        // Apply 'default' class for other routes
        return "text-base font-medium text-gray-700 font-sf-pro";
      }
    },
  },
};
</script>

<style scoped>
/* Add any additional styling here if needed */
</style>
